import { FunctionComponent, ReactNode, useState } from "react";
import { observer } from "mobx-react-lite";

import { getStoreContextProvider, store } from "../../../stores/StoreContext";

interface IStoreProviderProps {
  children: ReactNode;
}

const RawStoreProvider: FunctionComponent<IStoreProviderProps> = ({ children }: IStoreProviderProps) => {
  const [state, setState] = useState(store);

  const StoreContextProvider = getStoreContextProvider();

  return <StoreContextProvider value={state}>{children}</StoreContextProvider>;
};

export const StoreProvider = observer(RawStoreProvider);
